import React, { useEffect, useState } from "react";
import { Loader2, AlertTriangle, PackageOpen, Ship, Truck, ArrowRight } from "lucide-react";
import { api } from "../../lib/api";
import { STEP_TONE } from "./fxui";

const STAGE_TAB = ["fx-orders", "fx-picking", "fx-packing", "fx-containers", "fx-inbound", "fx-delivery", "fx-orders"];

export default function OpsBoard({ onGo }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/fx/stats").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d) return <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#306D29]" /></div>;

  const steps = d.public_steps || [];
  return (
    <div data-testid="fx-board">
      {d.exceptions > 0 && (
        <button onClick={() => onGo("fx-orders")} data-testid="fx-board-exceptions"
          className="w-full mb-6 bg-[#B23B3B]/10 border border-[#B23B3B]/30 text-[#B23B3B] rounded-2xl px-5 py-4 flex items-center gap-3 text-left hover:bg-[#B23B3B]/15">
          <AlertTriangle size={20} />
          <span className="font-semibold flex-1">{d.exceptions} order{d.exceptions > 1 ? "s" : ""} need attention (item exceptions)</span>
          <ArrowRight size={18} />
        </button>
      )}

      <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#306D29] mb-3">Orders by stage</p>
      <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-3 mb-8">
        {steps.map((label, i) => {
          const count = (d.step_counts || {})[label] || 0;
          return (
            <button key={i} onClick={() => onGo(STAGE_TAB[i] || "fx-orders")} data-testid={`fx-board-stage-${i}`}
              className="bg-white border border-black/5 rounded-2xl p-4 text-left hover:border-[#306D29]/40 hover:shadow-[0_10px_28px_rgba(13,83,14,0.08)]"
              style={{ transition: "border-color 0.2s ease, box-shadow 0.2s ease" }}>
              <p className="font-display text-4xl text-[#0D530E]">{count}</p>
              <span className={`inline-block mt-2 px-2 py-0.5 rounded-full text-[10px] font-semibold ${STEP_TONE[i] || STEP_TONE[0]}`}>{label}</span>
            </button>
          );
        })}
      </div>

      <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#306D29] mb-3">Operations</p>
      <div className="grid grid-cols-3 gap-3">
        <Mini icon={PackageOpen} label="Packages" value={d.packages} onClick={() => onGo("fx-packing")} />
        <Mini icon={Ship} label="Containers" value={d.containers} onClick={() => onGo("fx-containers")} />
        <Mini icon={Truck} label="Delivery queue" value={d.delivery_queue} onClick={() => onGo("fx-delivery")} />
      </div>
    </div>
  );
}

function Mini({ icon: Icon, label, value, onClick }) {
  return (
    <button onClick={onClick} className="bg-white border border-black/5 rounded-2xl p-5 text-left hover:border-[#306D29]/40" style={{ transition: "border-color 0.2s ease" }}>
      <div className="flex items-center gap-2 text-[#5C5C5C] mb-2"><Icon size={16} /><span className="text-xs uppercase tracking-wider">{label}</span></div>
      <p className="font-display text-3xl text-[#0D530E]">{value}</p>
    </button>
  );
}
